import { render, staticRenderFns } from "./AlienMessageLetter.vue?vue&type=template&id=483555c0&scoped=true&"
import script from "./AlienMessageLetter.vue?vue&type=script&lang=ts&"
export * from "./AlienMessageLetter.vue?vue&type=script&lang=ts&"
import style0 from "./AlienMessageLetter.vue?vue&type=style&index=0&id=483555c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483555c0",
  null
  
)

export default component.exports